module.exports = __webpack_public_path__ + "img/fb-post-03.2481a216.webp";